"use client";

import { EdgenModalCreateAble } from "@/src/components/EdgenModal";
import { callEdgenModalWhenRootReadyAsync } from "@/src/components/EdgenModal/waitForEdgenModalRoot";
import { finishOnboardingModal } from "@/src/components/ChatOnboarding/shared/finishOnboardingModal";
import { OnboardingPlanWelcomeModalContent } from "./OnboardingPlanWelcomeModalContent";
import { ONBOARDING_PLAN_WELCOME_MODAL_PROPS } from "./onboardingPlanWelcomeShell";
import type {
  OnboardingPlanWelcomeResult,
  OpenOnboardingPlanWelcomeModalParams,
} from "./types";

/** 防重入：连续点击或 Strict Mode 双挂载时复用同一 Promise，避免叠两层 Modal */
let pendingOnboardingPlanWelcomeModal: Promise<OnboardingPlanWelcomeResult> | null =
  null;

/**
 * 打开 Plan Welcome 弹窗（save_goal 前置步 / Setting DEBUG）。
 */
export const openOnboardingPlanWelcomeModal = (
  params: OpenOnboardingPlanWelcomeModalParams = {},
): Promise<OnboardingPlanWelcomeResult> => {
  if (pendingOnboardingPlanWelcomeModal) {
    return pendingOnboardingPlanWelcomeModal;
  }

  pendingOnboardingPlanWelcomeModal = callEdgenModalWhenRootReadyAsync(
    () =>
      new Promise<OnboardingPlanWelcomeResult>((resolve) => {
        let settled = false;

        const finish = (result: OnboardingPlanWelcomeResult) => {
          if (settled) {
            return;
          }
          settled = true;
          pendingOnboardingPlanWelcomeModal = null;

          void finishOnboardingModal(result, {
            handlers: params.handlers,
            onComplete: params.onComplete,
          }).finally(() => {
            EdgenModalCreateAble.end(false);
            resolve(result);
          });
        };

        EdgenModalCreateAble.call({
          children: (
            <OnboardingPlanWelcomeModalContent
              onClose={(action) => {
                finish({ action });
              }}
            />
          ),
          ...ONBOARDING_PLAN_WELCOME_MODAL_PROPS,
        });
      }),
  ).catch((error) => {
    pendingOnboardingPlanWelcomeModal = null;
    throw error;
  });

  return pendingOnboardingPlanWelcomeModal;
};
